module.exports = __webpack_public_path__ + "img/pic8.427ee41d.png";